module.exports = __webpack_public_path__ + "static/img/Hsiao_Wei_Lin.jpg";